module.exports = __webpack_public_path__ + "img/image-18.190b1d98.jpg";